export default {
  login: {
    title: 'Entra en tu cuenta.',
    mail: 'Correo',
    password: 'Contraseña',
    button: {
      confirm: 'Entra',
      forgot: 'Recuperar contraseña'
    },
    dialog: {
      notfound: {
        title: 'Acceso no autorizado',
        text: 'Usuario o contraseña incorrectos',
        confirm: 'Aceptar'
      },
      problems: {
        title: 'Estamos haciendo tareas de mantenimiento',
        text: 'Porfavor, vuelva a intentar mas tarde. Disculpe las molestias.',
        confirm: 'Aceptar'
      }
    }
  },
  register: {
    title: 'Registro',
    mail: 'Correo',
    terms_text: 'Terminos y condiciones.',
    terms_check: 'Yo acepto los terminos y condiciones de uso y privacidad.',
    privacy_text: 'Terminos de privacidad.',
    privacy_check: 'Terminos de uso.',
    button: {
      confirm: 'Registrar'
    },
    dialog_contract: {
      terms: 'Terminos y condiciones',
      privacy: 'Terminos de privacidad',
      close: 'Cerrar'
    },
    dialog: {
      confirm: {
        title: 'Revisa tu correo electronico',
        text: 'Te hemos mandado un correo para verificar tu dirección. Gracias.',
        confirm: 'Aceptar'
      },
      exists: {
        title: 'Existe una cuenta con este correo',
        text: 'Este correo electrónico ya existe en nuestro sistema.',
        confirm: 'Aceptar'
      },
      noverifytoken: {
        title: 'Problema verificando Captcha!',
        text: 'Hemos tenido un problema verificando el captcha de Google. Vuelva a intentarlo porfavor.',
        confirm: 'Aceptar'
      },
      invaliddata: {
        title: 'Datos erróneos',
        text: 'Porfavor, rellena tus datos.',
        confirm: 'Aceptar'
      },
      invalidtoken: {
        title: 'Estamos en mantenimiento',
        text: 'Vuelva a intentarlo pasado unos minutos. Disculpe las molestias.',
        confirm: 'Aceptar'
      },
      problems: {
        title: 'We are in maintenance',
        text: 'Try in a few minutes. If the problem persists contact technical assistance.',
        confirm: 'Aceptar'
      }
    },
    rules: {
      mail_required: 'Correo electrónico requerido',
      mail_valid: 'Correo electrónico debe ser valido',
      terms_check: 'Debe aceptar los terminos y condiciones.',
      privacy_check: 'Debe aceptar los terminos de privacidad.'
    }
  },
  forgot: {
    title: 'Solicitar una nueva contraseña',
    mail: 'Correo',
    button: {
      confirm: 'Solicitar nueva contraseña'
    },
    dialog: {
      confirm: {
        title: 'Mira tu buzon!',
        text: 'Hemos enviado un correo con una dirección para cambiar tu contraseña.',
        confirm: 'Aceptar'
      },
      problems: {
        title: 'Estamos en mantenimiento',
        text: 'Vuelva a intentarlo pasado unos minutos. Disculpe las molestias.',
        confirm: 'Aceptar'
      }
    }
  },
  users_panel: {
    input_label: 'Buscar usuario',
    id: 'Id',
    mail: 'Correo',
    firstname: 'Nombre',
    lastname: 'Apellido',
    id_card: 'DNI',
    address: 'Dirección',
    postal_code: 'Código Postal',
    city: 'Ciudad',
    country: 'País',
    created_at: 'Fecha Alta',
    status: {
      title: 'Estado',
      inactive: 'Inactivo',
      active: 'Activo',
      block: 'Bloqueado'
    },
    no_data: 'No hay datos disponibles',
    activeworkersdigital: 'Rq News',
    activeworkersyoutube: 'Rq Yout',
    activeworkersinstagram: 'Wk Inst',
    activeworkersfacebook: 'Wk Face',
    activeworkerstwitter: 'Wk Twit',

    activeworkersdigitalmax: 'Rq News MAX',
    activeworkersyoutubemax: 'Rq Yout MAX',
    activeworkersinstagrammax: 'Wk Inst MAX',
    activeworkersfacebookmax: 'Wk Face MAX',
    activeworkerstwittermax: 'Wk Twit MAX'
  },
  client_dashboard: {
    title: 'Visión General de Servicios',
    estadisticas: 'Estadísticas',
    latest: 'Últimas 10 peticiones',
    token: 'Servicios',
    sitebar: {
      title: 'Descripción:',
      description: 'Esta es tu vista principal. Muestra los servicios que has configurado y el uso actual.',

      sub_title_01: 'Puntos Clave:',
      sub_description_01: '',

      li_01_title_01: 'Servicios Configurados:',
      li_01_text_01: 'Cada línea “API” representa un servicio específico (p.ej., News, YouTube).',

      li_01_title_02: 'Requests Restantes:',
      li_01_text_02: 'Muestra cuántas solicitudes puedes hacer aún para ese servicio.',

      li_01_title_03: 'Tokens:',
      li_01_text_03: 'Tu clave de acceso única para cada servicio. Mantenla en secreto.',

      li_01_title_04: 'Workers:',
      li_01_text_04: 'Recursos trabajando para ese servicio. ¡Observa el conteo!',

      li_01_title_05: 'Actualización:',
      li_01_text_05: '¿Necesitas más Requests o Workers? Pulsa "Ampliar" para hablar con nuestro equipo de upgrades.',

      tips_title: 'Consejos:',
      tips_description: 'Revisa regularmente las "Solicitudes Restantes" para prevenir interrupciones en el servicio.'
    }
  },
  statistics: {
    title: 'Estadísticas',
    consumed: 'Consumido',
    latest: 'Últimas Requests',
    token: 'Servicios',
    sitebar: {
      title: 'Descripción:',
      description: 'Esta sección ofrece una visión general de tus patrones de consumo y las recientes solicitudes realizadas a las APIs.',

      sub_title_01: 'Puntos Clave:',
      sub_description_01: '',

      li_01_title_01: 'Request Consumidas:',
      li_01_text_01: 'Gráfico visual que muestra las solicitudes diarias en diferentes servicios.',

      li_01_title_02: 'Últimas 10 request:',
      li_01_text_02: 'Un registro en tiempo real de las últimas 10 llamadas a la API con detalles como fecha, IP, servicio, agente del usuario y la carga útil de la solicitud real.',

      tips_title: 'Consejos:',
      tips_description: 'Revisa esta sección regularmente para monitorear el uso de tu servicio y asegurarte de que estás aprovechando al máximo la plata.'
    }
  },
  playground: {
    title: 'Playground',
    subtitle: 'Prueba el API',
    title_digital: 'News',
    title_youtube: 'YouTube',
    title_instagram: 'Instagram',
    title_facebook: 'Facebook',
    title_twitter: 'Twitter',
    title_law: 'Legal',
    title_newspro: 'News Pro',
    title_tiktok: 'TikTok',
    search_query: 'Introducir expresión de búsqueda',
    worker_selected: 'Selecciona un Worker',
    hint_search: 'usa expresiones con el formato explicado en la documentación, sección Expresiones de búsqueda ',
    results: 'Resultados',
    list: ' (100 resultados mostrados)',
    list_10: ' (10 resultados mostrados)',
    list_50: ' (50 resultados mostrados)',
    get_results: 'Buscar!',
    request_remaining: 'Búsquedas restantes',
    format: 'Formato',
    order: 'Prioridad orden captura',
    direction: 'Orden de fecha',
    time: 'Periodo',
    date_limit: 'fecha: inicio',
    date_limit_range: 'fecha: fin',
    modeviewer: 'Modos',
    modeweb: 'WEB',
    modejson: 'JSON',
    modetable: 'TABLE',
    new_view: {
      title: 'Título: ',
      url: 'URL: ',
      rack: 'Alexa Rank:',
      published: 'Publicado: ',
      published_by: 'Site: ',
      language: 'Idioma: ',
      site_country: 'Pais: ',
      site_type: 'Tipo: ',
      author: 'Autor: ',
      rank: 'Rank: ',
      unique_visitors: 'Audiencia: ',
      value: 'Valor: ',
      site_language: 'Idioma:',
      read_more: '... leer más'
    },
    law_view: {
      title: 'Título: ',
      url: 'URL: ',
      published: 'Publicado: ',
      published_by: 'Site: ',
      language: 'Idioma: ',
      site_country: 'Pais: ',
      site_type: 'Tipo: ',
      read_more: '... leer más'
    },
    youtube_view: {
      title: 'Titulo: ',
      published: 'Publicado: ',
      url: 'URL: ',
      description: 'Descripción: ',
      channel: 'Canal: ',
      language: 'Idioma: ',
      views: 'Visualizaciones: ',
      likes: 'Likes: ',
      dislikes: 'Dislikes: ',
      favourites: 'Favoritos: ',
      comments: 'Comentarios: '
    },
    instagram_view: {
      published: 'Publicado: ',
      type: 'Tipo: ',
      likes: 'Likes: ',
      dislikes: 'Dislikes: ',
      user_name: 'Nombre usuario: ',
      screen_name: 'Nombre: ',
      publications: 'Publicaciones: ',
      followers: 'Seguidores: ',
      followed: 'Seguidos: ',
      favourites: 'Favoritos: ',
      comments: 'Comentarios: ',
      text: 'Texto: ',
      url: 'URL: '
    },
    facebook_view: {
      published: 'Publicado: ',
      type: 'Tipo: ',
      likes: 'Likes: ',
      user_name: 'Nombre usuario: ',
      screen_name: 'Nombre: ',
      publications: 'Publicaciones: ',
      shared: 'Comparticiones: ',
      comments: 'Comentarios: ',
      url: 'URL: '
    },
    twitter_view: {
      published: 'Publicado: ',
      location: 'Localización: ',
      site: 'Site: ',
      retweet: 'Retweet: ',
      retweets: 'Retweeted: ',
      reply_count: 'Réplicas: ',
      quote_count: 'Citas: ',
      favourite_count: 'Favoritos: ',
      user_name: 'Nombre usuario: ',
      screen_name: 'Nombre: ',
      follower_count: 'Followers del usuario: ',
      friends_count: 'Amigos del usuario: ',
      following_count: 'Usuarios seguidos del usuario: ',
      favourites_count: 'Favoritos del usuario: ',
      reproductions_count: 'Reproducciones: ',
      statuses_count: 'Estados de usuario: ',
      entities_url: 'URL entities: ',
      url: 'URL',
      lang: 'Idioma: '
    },
    dialog: {
      alert: {
        title: 'Atención',
        text: 'Por favor agregue las condiciones de búsqueda',
        confirm: 'Aceptar'
      }
    },
    sitebar: {
      title: 'Descripción:',
      description:
        'La sección "PlayGround" es un entorno interactivo que permite a los usuarios probar y experimentar con diversas combinaciones de consultas y filtros antes de comprometerse con una configuración de llamada API. Empodera a los usuarios para elaborar las consultas más eficientes según sus necesidades.',

      sub_title_01: 'Puntos Clave:',
      sub_description_01: '',

      li_01_title_01: 'Resultados en Vivo:',
      li_01_text_01:
        'A medida que los usuarios ajustan los parámetros de búsqueda, verán resultados en tiempo real. Esta retroalimentación inmediata ayuda a validar la calidad y cantidad de datos que pueden esperar de sus configuraciones.',

      li_01_title_02: 'Contador de Resultados:',
      li_01_text_02: 'Se muestra un recuento dinámico, ofreciendo a los usuarios una proyección del volumen de datos que podrían estar descargando diariamente de las llamadas API.',

      li_01_title_03: 'Visualización de End Point:',
      li_01_text_03:
        'A medida que se construye la configuración óptima, se genera una URL como https://api.trawlingweb.com/?token=[TOKEN]&q=[CONSULTA]. Esto puede ser referido como el "End Point" y será crucial para que los usuarios lo incorporen en sus sistemas para las llamadas API posteriores.',

      sub_title_02: 'Opciones de configuración de Playground:',
      sub_description_02: 'Dentro de la sección "PlayGround", los usuarios tienen la capacidad de ajustar sus parámetros de búsqueda según dos tipos principales de configuración.',

      /*  ------------- */
      li_subtitle_01_01: 'APIs que Funcionan por Solicitud de Búsqueda:',
      li_subtext_01_01: '',

      li_subli_title_01_01: 'APIs incluidas:',
      li_subli_text_01_01: 'API de Noticias, API de YouTube y API Legal.',

      li_subli_title_01_02: 'Configuración:',
      li_subli_text_01_02:
        'Los usuarios pueden elaborar combinaciones utilizando consultas de búsqueda Booleanas y aplicar filtros utilizando la sintaxis de LUCENE. Esto ofrece un medio poderoso y preciso para acceder a puntos de datos específicos dentro de estas APIs.',

      li_subli_title_01_03: 'Consejo:',
      li_subli_text_01_03: 'Familiarízate con la sintaxis de LUCENE para extraer los resultados más relevantes.',

      /*  ------------- */
      li_subtitle_02_01: 'APIs que Usan Workers:',
      li_subtext_02_01: '',

      li_subli_title_02_01: 'Descripción:',
      li_subli_text_02_01:
        'Para plataformas de redes sociales, como API Instagram, API Facebook o API Twitter donde la extracción de datos se basa en workers, las opciones de búsqueda no son configurables en tiempo real dentro del PlayGround. En su lugar, los usuarios solo pueden listar y ver el contenido devuelto basado en la configuración previa del worker.',

      li_subli_title_02_02: 'Importancia:',
      li_subli_text_02_02: 'Este método asegura que los usuarios verifiquen la calidad y cantidad de resultados que sus workers producen antes de hacer llamadas en vivo.',

      li_subli_title_02_03: 'Consejo:',
      li_subli_text_02_03: 'Revisa y ajusta regularmente las configuraciones de tus workers para asegurar resultados óptimos.',

      /*  ------------- */
      tips_title: 'Consejos:',
      tips_description_01:
        'Utiliza el PlayGround para refinar tus parámetros de búsqueda hasta que logres el volumen y calidad de resultados deseados para tus necesidades. Recuerda, cuanto más precisa sea tu consulta, más relevantes serán tus resultados.',
      tips_description_02: 'Para más información sobre la configuración y uso de las APIs de TrawlingWeb, puede dirigirse a la sección "Documentación" que se encuentra en el menú superior.'
    }
  },
  shop: {
    title: 'Tienda',
    title_ondemand: 'Productos bajo demanda',
    title_adhoc: 'Tu producto Adhoc',
    step1: 'Paso 1: Selecciona producto',
    step2: 'Paso 2: Selecciona peticiones mensuales',
    characteristics: 'Características',
    request_remaining: 'Peticiones restantes',
    title_not_admin: 'El servicio en mantenimiento',
    service: 'Servicio',
    buy: 'Siguiente',
    req_month: 'Peticiones/M',
    price_month: 'Precio/M',
    results: 'Resultados totales',
    dialog: {
      same: {
        title: 'Atención',
        text: 'Ya tienes este producto.',
        confirm: 'Aceptar'
      },
      developer: {
        title: 'Atención',
        text: 'Cambiando a producto Developer.',
        confirm: 'Confirmar cambio',
        cancel: 'Cancel'
      },
      downgrade: {
        title: 'Atención',
        text: 'Cambiando a producto "{product_name}".',
        confirm: 'Confirmar cambio',
        cancel: 'Cancel'
      }
    }
  },
  consumer: {
    request: 'Request restantes de',
    workers: 'Workers',
    nextmonth: 'Fecha de renovación:',
    token: 'Token',
    title_digital: 'News',
    title_newspro: 'News Pro',
    title_youtube: 'YouTube',
    title_instagram: 'Instagram',
    title_facebook: 'Facebook',
    title_twitter: 'Twitter',
    title_law: 'Legal',
    upselling: 'Ampliar',
    token_copy: 'Token copiado',
    close: 'Cerrar',
    upgrade: 'Solicitada ampliación el producto. Nos pondremos en contacto'
  },
  documentation: {
    title: 'Documentación',
    subtitle: 'Documentación técnica',
    sitebar: {
      title: 'Descripción:',
      description:
        'Esta sección es esencial para aquellos usuarios que buscan profundizar su entendimiento y capacidad de uso de TrawlingWeb. Aquí encontrarás guías detalladas, tutoriales y ejemplos prácticos que te ayudarán a aprovechar al máximo todas las funciones y herramientas que nuestra plataforma ofrece. Tanto si eres un novato en el mundo de las APIs como si eres un experto, nuestra documentación está diseñada para brindarte la información que necesitas en cada paso de tu viaje con TrawlingWeb.',

      tips_title: 'Consejos:',
      tips_description:
        'Te recomendamos revisar esta sección antes de hacer consultas o configuraciones avanzadas. La documentación es una excelente fuente de referencia que puede ahorrarte tiempo y esfuerzo.'
    }
  },
  usereditor: {
    title: 'Usuario',
    consumer_info: 'Información del producto',
    dialog: {
      confirm: {
        title: 'Confirmación',
        text: 'Información actualizada',
        confirm: 'Aceptar'
      },
      problems: {
        title: 'Acción en mantenimento',
        text: 'Pruebe en unos minutos.',
        confirm: 'Aceptar'
      }
    },
    latest: 'Últimas 10 Peticiones',
    token: 'Servicio',
    graphic: 'Peticiones Mensuales',
    orders: 'Pedidos',
    workers_stats: 'Workers Stats'
  },
  language: {
    title: 'Idioma'
  },
  exit: {
    title: 'Salir'
  },
  settings: {
    title: 'Ajustes',
    title_user: 'Información personal',
    terms_title: 'Terminos y condiciones aceptados',
    terms_text: 'Terminos y condiciones.',
    privacy_text: 'Política de privacidad.',
    delete_account_title: 'Eliminar la cuenta',
    delete_account: 'Elimina mi cuenta ahora',
    dialog_delete: {
      title: 'PELIGRO',
      message: 'Estás apunto de eliminar tu cuenta. Perderás todos tus datos y configuraciones.',
      cancel: 'Cancelar',
      confirm: 'Confirmar'
    },
    dialog_contract: {
      terms: 'Terminos y condiciones',
      privacy: 'Política de privacidad',
      close: 'Cerrar'
    },
    sitebar: {
      title: 'Descripción:',
      description:
        'La sección "Configuración" ofrece una plataforma centrada en el usuario donde se pueden ver y editar los detalles personales y organizativos. Esto asegura que toda la información vinculada a la cuenta del usuario sea actual y precisa. Aquí está lo que contiene.',

      sub_title_01: 'Puntos Clave:',
      sub_description_01: '',

      li_01_title_01: 'Editor de Usuario:',
      li_01_text_01: 'Una interfaz que permite al usuario realizar los cambios necesarios en su perfil.',

      li_01_title_02: 'Correo:',
      li_01_text_02: 'La dirección de correo electrónico principal asociada a la cuenta, crucial para comunicaciones y notificaciones.',

      li_01_title_03: 'Nombre y Apellido:',
      li_01_text_03: 'Identificadores personales esenciales, que garantizan que las comunicaciones e interacciones sean personalizadas.',

      li_01_title_04: 'Organización:',
      li_01_text_04: 'El nombre de la empresa o entidad a la que está afiliado el usuario, útil para facturación y propósitos organizativos.',

      li_01_title_05: 'Teléfono:',
      li_01_text_05: 'Un número de contacto para comunicación directa o consultas relacionadas con la cuenta.',

      li_01_title_06: 'Identificación VAT de la  Organización:',
      li_01_text_06: 'Un identificador único, esencial para propósitos fiscales, de facturación y verificación.',

      li_01_title_07: 'Detalles de Dirección:',
      li_01_text_07: 'Incluyendo la calle, código postal, ciudad y país, necesarios para facturación y envío.',

      li_01_title_08: 'Idioma:',
      li_01_text_08: 'Configuración de idioma preferido para el panel, garantizando una experiencia de usuario cómoda.',

      li_01_title_09: 'Código Promocional:',
      li_01_text_09: 'Un campo opcional donde los usuarios pueden introducir códigos promocionales para descuentos u ofertas especiales.'
    }
  },
  usermanager: {
    title: 'Administrador de usuarios'
  },
  billing: {
    title: 'Facturación',
    id: 'Id',
    user: 'Usuario',
    consumer: 'Producto',
    firstname: 'Nombre',
    lastname: 'Apellidos',
    billing_type: 'Tipo',
    billing_date: 'Fecha Facturación',
    product_type: 'Tipo producto',
    product_name: 'Descripción producto',
    price: 'Precio total',
    view_order: 'Ver pedido',
    view_invoice: 'Ver factura',
    city: 'Ciudad',
    web: 'Compra Web',
    autorenew: 'Auto renovación',
    manual: 'Compra directa',
    transaction_type: 'Tipo de transacción',
    country: 'País',
    order: 'Pedido',
    invoice: 'Factura',
    status: {
      title: 'Estado',
      inactive: 'Inactivo',
      active: 'Activo',
      block: 'Bloqueado'
    },
    no_data: 'Sin información disponible'
  },
  order: {
    order_num: 'Número de pedido:',
    billing_date: 'Fecha de facturación: ',
    base_price: 'Precio base',
    total_price: 'Total',
    taxes: 'Impuestos ',
    print: 'Imprimir'
  },
  invoice: {
    invoice_num: 'Código de factura:',
    billing_date: 'Fecha de factura:',
    base_price: 'Precio base',
    total_price: 'Total',
    taxes: 'Impuestos',
    print: 'Imprimir'
  },
  userform: {
    mail: 'Email',
    password: 'Password',
    firstname: 'Nombre',
    lastname: 'Apellidos',
    company: 'Empresa',
    id_card: 'NIF o VAT',
    address: 'Dirección',
    phone: 'Teléfono',
    postal_code: 'Código postal',
    city: 'Ciudad',
    country: 'País',
    language: 'Idioma',
    promo_code: 'Código Promocional',
    vatbutton: {
      validate: 'Validación VAT',
      ok: 'VAT valido!',
      ko: 'VAT invalido. Reintentar!'
    },
    button: {
      confirm: 'Confirma información personal',
      change: 'Guardar cambios',
      cancel: 'Cancela'
    },
    dialog: {
      confirm: {
        title: 'Confirmación',
        text: 'Su información personal ha sido actualizada',
        confirm: 'Aceptar'
      },
      invaliddata: {
        title: 'Datos erróneos',
        text: 'Porfavor, rellena tus datos.',
        confirm: 'Aceptar'
      },
      problems: {
        title: 'Estamos en mantenimiento',
        text: 'Pruebe en unos minutos.',
        confirm: 'Aceptar'
      },
      warning: {
        title: 'Atención',
        text: 'Estos datos se usarán para su facturación. Por lo tanto, confirmas que los datos introducidos son reales.',
        confirm: 'Confirme los valores',
        cancel: 'Cancel'
      }
    },
    rules: {
      password_required: 'Longitud mínima de 8 caracteres alfanuméricos',
      mail_required: 'El e-mail es necesario',
      mail_valid: 'El e-mail debe ser valido',
      firstname_required: 'El nombre es necesario',
      lastname_required: 'Los apellidos son necesario',
      lastname_valid: 'Los apellidos deben ser valido',
      id_card_required: 'El NIF es necesario',
      id_card_valid: 'El NIF debe ser valido',
      address_required: 'La dirección es necesaria',
      address_valid: 'La dirección debe ser valida',
      postal_code_required: 'El código postal es necesario',
      postal_code_valid: 'El código postal debe ser valido',
      city_required: 'La ciudad es necesaria',
      city_valid: 'La ciudad debe ser valida',
      country_required: 'El país es necesario'
    }
  },
  validate_settings: {
    title: 'Validar la configuración'
  },
  confirm: {
    title: 'Confirmación de la transacción',
    ok: {
      title: 'La transacción se ha completado con éxito.',
      message: 'Acceda a su producto en el "dashboard".',
      button: 'Volver al "Panel de control"'
    },
    ko: {
      title: 'El pago ha sido cancelado o la tarjeta ha sido rechazada.',
      button: 'Volver a la "tienda"'
    },
    info: {
      title: 'Order request not found',
      button: 'Volver al "Panel de control"'
    }
  },
  confirm_ondemand: {
    title: 'Confirmación de la compra',
    ok: {
      title: 'La compra se ha completado con éxito.',
      message: 'Acceda a su producto en el "dashboard".',
      button: 'Volver al "Panel de control"'
    }
  },
  downgrade: {
    title: 'Transacción confirmada',
    loading: 'Procesando su pedido',
    confirm: 'Su producto ha cambiado al tipo "{product_name}".',
    problem: 'Problemas con el cambio de producto, inténtelo dentro de unos minutos.',
    button: 'Volver al "Panel de control"'
  },
  shopcart: {
    request: 'Peticiones mensuales',
    title: 'Paso 3: Su elección',
    checkout: 'Siguiente',
    cancel: 'Cancelar',
    order: 'Pedido'
  },
  workers: {
    title: 'Workers config',
    subtitle: 'Gestiona Workers',
    title_status: 'Workers usados',
    title_instagram: 'Instagram',
    title_facebook: 'Facebook',
    title_twitter: 'Twitter',
    title_newspro: 'News Pro',
    status_start: 'Trabajando',
    status_stop: 'Pausado',
    worker: 'worker',
    captures: 'Consulta',
    worker_id: 'Worker ID',
    info: 'Solicita información de nuestros servicos de captura en redes sociales.',
    more: 'Solicita más Workers para configurar el rastreo en redes sociales.',
    email: 'support@trawlingweb.com',
    telefon: '‎+34 684 38 84 66',
    status_update: 'Workers actualizados',
    sitebar: {
      instagram: {
        title: 'Descripción:',
        description: 'Esta sección está dedicada a gestionar y visualizar los workers que has configurado para el monitoreo en Instagram.',

        sub_title_01: 'Puntos Clave:',
        sub_description_01: '',

        li_01_title_01: 'Iconos de Worker:',
        li_01_text_01: 'Representan cada worker configurado. El ícono, como developer_board, indica un worker activo.',

        li_01_title_02: 'Plataforma:',
        li_01_text_02: 'Instagram',

        li_01_title_03: 'Nombre del Cliente y Propósito:',
        li_01_text_03: 'Describe quién es el cliente y el tema o rama específica que se está monitoreando.',

        li_01_title_04: 'ID del Worker:',
        li_01_text_04: 'Un identificador único para cada worker.',

        li_01_title_05: 'Publicaciones de Consulta:',
        li_01_text_05: 'Enlaces para ver las publicaciones específicas extraídas por el worker.',

        li_01_title_05: 'Palabras:',
        li_01_text_05: 'Palabras clave definidas por el usuario que el worker utiliza para extraer contenido en Instagram.',

        sub_title_02: 'Añadir un Nuevo Worker:',
        sub_description_02: 'Para monitorear más palabras clave en Instagram.',
        li_02_text_01: 'Selecciona la plataforma Instagram desde el menú superior.',
        li_02_text_02: 'Haz clic en "CREAR WORKER".',
        li_02_text_03:
          'Configura e introduce tus palabras clave deseadas para este nuevo worker. Nota: Recuerda que, para Instagram, solo puedes agregar palabras clave que sean aceptadas por la sintaxis de búsqueda de la plataforma. Esto incluye palabras con # y menciones o usuarios precedidos por @.',

        tips_title: 'Consejos: ',
        tips_description: '',
        li_tips_01: 'Actualiza regularmente tus palabras clave para asegurarte de capturar todo el contenido relevante en las plataformas de redes sociales.',
        li_tips_02: 'Para más información sobre la configuración y uso de los workers de cada API de TrawlingWeb, puede dirigirse a la sección "Documentación" que se encuentra en el menú superior.'
      },
      facebook: {
        title: 'Descripción:',
        description: 'Esta sección está dedicada a gestionar y visualizar los workers que has configurado para el monitoreo en Facebook.',

        sub_title_01: 'Puntos Clave:',
        sub_description_01: '',

        li_01_title_01: 'Iconos de Worker:',
        li_01_text_01: 'Representan cada worker configurado. El ícono, como developer_board, indica un worker activo.',

        li_01_title_02: 'Plataforma:',
        li_01_text_02: 'Facebook',

        li_01_title_03: 'Nombre del Cliente y Propósito:',
        li_01_text_03: 'Describe quién es el cliente y el tema o rama específica que se está monitoreando.',

        li_01_title_04: 'ID del Worker:',
        li_01_text_04: 'Un identificador único para cada worker.',

        li_01_title_05: 'Publicaciones de Consulta:',
        li_01_text_05: 'Enlaces para ver las publicaciones específicas extraídas por el worker.',

        li_01_title_05: 'Palabras:',
        li_01_text_05: 'Palabras clave definidas por el usuario que el worker utiliza para extraer contenido en Facebook.',

        sub_title_02: 'Añadir un Nuevo Worker:',
        sub_description_02: 'Para monitorear más palabras clave en Facebook.',
        li_02_text_01: 'Selecciona la plataforma Facebook desde el menú superior.',
        li_02_text_02: 'Haz clic en "CREAR WORKER".',
        li_02_text_03:
          'Configura e introduce tus palabras clave deseadas para este nuevo worker. Nota: Para Facebook, puedes agregar palabras clave que sean aceptadas por la sintaxis de búsqueda de la plataforma, incluyendo palabras con #, menciones o usuarios precedidos por @, así como palabras sin # ni @, ya que el buscador de la red social lo permite.',

        tips_title: 'Consejos: ',
        tips_description: '',
        li_tips_01: 'Actualiza regularmente tus palabras clave para asegurarte de capturar todo el contenido relevante en las plataformas de redes sociales.        ',
        li_tips_02: 'Para más información sobre la configuración y uso de los workers de cada API de TrawlingWeb, puede dirigirse a la sección "Documentación" que se encuentra en el menú superior.'
      },
      twitter: {
        title: 'Descripción:',
        description: 'Esta sección está dedicada a gestionar y visualizar los workers que has configurado para el monitoreo en Twitter.',

        sub_title_01: 'Puntos Clave:',
        sub_description_01: '',

        li_01_title_01: 'Iconos de Worker:',
        li_01_text_01: 'Representan cada worker configurado. El ícono, como developer_board, indica un worker activo.',

        li_01_title_02: 'Plataforma:',
        li_01_text_02: 'Twitter',

        li_01_title_03: 'Nombre del Cliente y Propósito:',
        li_01_text_03: 'Describe quién es el cliente y el tema o rama específica que se está monitoreando.',

        li_01_title_04: 'ID del Worker:',
        li_01_text_04: 'Un identificador único para cada worker.',

        li_01_title_05: 'Publicaciones de Consulta:',
        li_01_text_05: 'Enlaces para ver las publicaciones específicas extraídas por el worker.',

        li_01_title_05: 'Palabras:',
        li_01_text_05: 'Palabras clave definidas por el usuario que el worker utiliza para extraer contenido en Twitter.',

        sub_title_02: 'Añadir un Nuevo Worker:',
        sub_description_02: 'Para monitorear más palabras clave en Twitter.',
        li_02_text_01: 'Selecciona la plataforma Twitter desde el menú superior.',
        li_02_text_02: 'Haz clic en "CREAR WORKER".',
        li_02_text_03:
          'Configura e introduce tus palabras clave deseadas para este nuevo worker. Nota: Para Twitter, puedes agregar palabras clave que sean aceptadas por la sintaxis de búsqueda de la plataforma, incluyendo palabras con #, menciones o usuarios precedidos por @, así como palabras sin # ni @, ya que el buscador de la red social lo permite.',

        tips_title: 'Consejos: ',
        tips_description: '',
        li_tips_01: 'Actualiza regularmente tus palabras clave para asegurarte de capturar todo el contenido relevante en las plataformas de redes sociales.        ',
        li_tips_02: 'Para más información sobre la configuración y uso de los workers de cada API de TrawlingWeb, puede dirigirse a la sección "Documentación" que se encuentra en el menú superior.'
      }
    }
  },
  workers_add: {
    bt: 'Crear Worker',
    title: 'Nuevo Worker',
    description: 'Nombre del Worker',
    word: 'Palabra a buscar',
    bt_add: 'Crear',
    bt_sample: 'Ejemplos: #azul    @pedro    La casa blanca',
    bt_sample_fb: 'Ejemplos: #azul    @pedro    La casa blanca',
    required: '*Campos requeridos',
    close: 'Cerrar',
    save: 'Guardar',
    gestion: ' Gestionar Workers',
    alert_1: 'Agrega un nombre de Worker',
    alert_2: 'Nombre de Worker muy largo',
    alert_3: 'Agrega una palabra de búsqueda',
    alert_4: 'El primer carácter ha de ser un # o un @',
    alert_5: 'Palabra muy corta',
    alert_6: 'Carácter inapropiado'
  },
  workers_delete: {
    title: 'Borrar Worker',
    alert: '¡¡¡Atención!!!',
    text: 'Aceptando, borrará tanto la configuración del Worker como sus capturas almacenadas. ',
    text_2: '¿Está seguro? Una vez borrado, el Worker no se podrá recuperar.',
    close: 'Cerrar',
    save: 'Guardar'
  },
  shop_ondemand: {
    info: {
      0: 'Aumente su suscripción una sola vez sin alterar el compromiso mensual.',
      1: 'El aumento estará disponible hasta el final del ciclo de facturación actual.'
    }
  },
  requests_selector: {
    increase: 'Incremento'
  }
}
